<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
         <router-link to="/inicio" class="nav-link" :class="getRoute() === 'inicio' ? 'active' : ''">
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
      <i class="ni ni-tv-2 text-info text-sm opacity-10"></i>
    </div>
    <span
      class="nav-link-text ms-1"
      >Inicio</span
    >
  </router-link>
      </li>
      <li v-if="nivelacceso == 1" class="nav-item">
         <router-link to="/usuarios" class="nav-link"   :class="getRoute() === 'usuarios' ? 'active' : ''">
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
       <i class="ni ni-circle-08 text-info text-sm opacity-10"></i>
    </div>
    <span
      class="nav-link-text ms-1"
      >Usuarios</span
    >
  </router-link>
      </li>
      <li v-if="nivelacceso == 1" class="nav-item">
         <router-link to="/reportes" class="nav-link"   :class="getRoute() === 'reportes' ? 'active' : ''">
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
       <i class="ni ni-chart-bar-32 text-info text-sm opacity-10"></i>
    </div>
    <span
      class="nav-link-text ms-1"
      >Reportes</span
    >
  </router-link>
      </li>
      <li v-if="nivelacceso == 1" class="nav-item">
         <router-link to="/servicios" class="nav-link"   :class="getRoute() === 'servicios' ? 'active' : ''">
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
       <i class="ni ni-user-run text-info text-sm opacity-10"></i>
    </div>
    <span
      class="nav-link-text ms-1"
      >Admin Servicios</span
    >
  </router-link>
      </li>
       <li v-if="nivelacceso == 1" class="nav-item">
        <router-link to="/configuracion" class="nav-link"   :class="getRoute() === 'configuracion' ? 'active' : ''">
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
       <i class="ni ni-settings text-info text-sm opacity-10"></i>
    </div>
    <span
      class="nav-link-text ms-1"
      >Configuracion</span
    >
  </router-link>
      </li>
      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 me-4"
        >
          GESTION TURNOS
        </h6>
      </li>
      
      <li class="nav-item">
        <router-link to="/turnos" class="nav-link"   :class="getRoute() === 'turnos' ? 'active' : ''">
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
       <i class="ni ni-bell-55 text-info text-sm opacity-10"></i>
    </div>
    <span
      class="nav-link-text ms-1"
      >Gestionar Turnos</span
    >
  </router-link>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
    />
  </div>
</template>
<script>
import SidenavCard from "./SidenavCard.vue";

export default {
  name: "SidenavList",
 
  data() {
    return {
      nivelacceso:"",
    };
  },
  components: {
    SidenavCard
  },
    mounted() {
    this.nivelacceso = sessionStorage.getItem('nivel');
    
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    }
  }
};
</script>
<style scoped>
.coloriconos{
  color:linear-gradient(87deg, #64e1f7 0, #4f95f1 100%);
}
</style>
